"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.GetBucketLifecycleInput = {
    type: "structure",
    required: ["Bucket"],
    members: {
        Bucket: {
            shape: {
                type: "string"
            },
            location: "uri",
            locationName: "Bucket"
        }
    }
};
//# sourceMappingURL=GetBucketLifecycleInput.js.map